import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import get from 'lodash/get';

import { DescriptionItem, DescriptionList } from 'components/DescriptionList';

const BusinessPartnerPaymentDetails = ({ data }: { data: any }) => {
  return (
    <DescriptionList data={get(data, 'publisher.paymentDetails')}>
      <IonGrid>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'bankName'} label={'Bank Name'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'bankAddress'} label={'Bank Address'} />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'accountNumber'} label={'Account Number'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'accountName'} label={'Account'} />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'swiftCode'} label={'Swift Code'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'iban'} label={'IBAN'} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </DescriptionList>
  );
};

export default BusinessPartnerPaymentDetails;
